interface ILocationUpdateFrequency {
  duration: number | undefined,
  hint: string,
  text: string,
}

interface IInstalledCable {
  value: typeof InstalledCableTypes[keyof typeof InstalledCableTypes],
  text: string,
}

interface ISignalReportingField {
  value: typeof SignalReportingTypes[keyof typeof SignalReportingTypes],
  text: string,
}

function hoursToMinutes(hours: number): number | undefined {
  if (hours <= 0) return undefined;
  return (hours * 60);
}

const RECOMMENDED: string = $localize`(Recommended)`;
const REDUCES_BATTERY_LIFE: string = $localize`(Reduces battery life)`;
const INCREASES_BATTERY_LIFE: string = $localize`(Increases battery life)`;
const MAXIMIZES_BATTERY_LIFE = $localize`(Maximizes battery life)`;

const CHECK_IN_RATE: string = $localize`Check-In Rate`;
const ADDITIONAL_CHECK_IN_RATE: string = $localize`Additional Check-In`;
const defaulCheckInRateFrequency: number | undefined = hoursToMinutes(12);
const defaultUnpoweredCheckInRate: number | undefined = hoursToMinutes(12);
const defaultAdditionalCheckInFrequentFrequency: number | undefined = hoursToMinutes(2);
const defaultLocationFrequencyWithCriticalBatteryStatus: number | undefined = hoursToMinutes(24);

const checkInAdditionalFrequencies: ILocationUpdateFrequency[] = [
  {
    duration: hoursToMinutes(4),
    hint: REDUCES_BATTERY_LIFE,
    text: $localize`Every 4 hours`,
  },
  {
    duration: hoursToMinutes(6),
    hint: REDUCES_BATTERY_LIFE,
    text: $localize`Every 6 hours`,
  },
];

const checkInRateFrequencies: ILocationUpdateFrequency[] = [
  {
    duration: hoursToMinutes(8),
    hint: REDUCES_BATTERY_LIFE,
    text: $localize`Every 8 hours`,
  },
  {
    duration: hoursToMinutes(12),
    hint: RECOMMENDED,
    text: $localize`Every 12 hours`,
  },
  {
    duration: hoursToMinutes(24),
    hint: INCREASES_BATTERY_LIFE,
    text: $localize`Every 24 hours`,
  },
  {
    duration: hoursToMinutes(48),
    hint: MAXIMIZES_BATTERY_LIFE,
    text: $localize`Every 48 hours`,
  },
];

enum InstalledCableTypes {
  NO_CABLE = 'no_cable',
  THREE_WIRE = '3_wire',
  EIGHT_WIRE = '8_wire',
}

enum SignalReportingTypes {
  HIGH_ON = 'high_on',
  LOW_ON = 'low_on',
}

const installedCables: IInstalledCable[] = [
  {
    value: InstalledCableTypes.NO_CABLE,
    text: $localize`No Cable`,
  },
  {
    value: InstalledCableTypes.THREE_WIRE,
    text: $localize`3 Wire Cable`,
  },
  {
    value: InstalledCableTypes.EIGHT_WIRE,
    text: $localize`8 Wire Cable`,
  },
];

const signalReportingFields: ISignalReportingField[] = [
  {
    value: SignalReportingTypes.HIGH_ON,
    text: $localize`High is On`,
  },
  {
    value: SignalReportingTypes.LOW_ON,
    text: $localize`Low is On`,
  },
];

const additionalCheckInFrequentFrequencies: ILocationUpdateFrequency[] = [
  {
    duration: hoursToMinutes(1),
    hint: REDUCES_BATTERY_LIFE,
    text: $localize`Every 1 hour`,
  },
  {
    duration: hoursToMinutes(2),
    hint: RECOMMENDED,
    text: $localize`Every 2 hours`,
  },
  {
    duration: hoursToMinutes(4),
    hint: INCREASES_BATTERY_LIFE,
    text: $localize`Every 4 hours`,
  },
];

const defaultInstalledCable: string = InstalledCableTypes.NO_CABLE;

export {
  // enums
  InstalledCableTypes,
  SignalReportingTypes,
  // Interfaces
  IInstalledCable,
  ISignalReportingField,
  ILocationUpdateFrequency,
  // Constants
  CHECK_IN_RATE,
  installedCables,
  signalReportingFields,
  defaultInstalledCable,
  checkInRateFrequencies,
  ADDITIONAL_CHECK_IN_RATE,
  defaulCheckInRateFrequency,
  defaultUnpoweredCheckInRate,
  checkInAdditionalFrequencies,
  additionalCheckInFrequentFrequencies,
  defaultAdditionalCheckInFrequentFrequency,
  defaultLocationFrequencyWithCriticalBatteryStatus,
};

